(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/init.js');

'use strict';

if (svs.lotto.data.shouldUseReact) {
  svs.lotto.logger.debug('Lotto is running React component.');
} else {
  svs.numbergames.game_app.app.start({
    Router: svs.lotto.Router,
    product: svs.numbergames.productMapping.CONSTANTS.LOTTO
  });
}

 })(window);